/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
/* eslint-disable indent */

    var ErrorsCollection = require('../modules/collections/paymenterrormanager.collection');
    var ErrorsView = require('../modules/views/paymenterrormanager.view');

    Odigeo.defineWidget('paymenterrormanager', Odigeo.Widget.extend({
        ErrorsCollection: ErrorsCollection,
        viewClass: ErrorsView,
        errors: null,

        init: function() {
            this.errors = new this.ErrorsCollection(null, {widget: this});
            this.errors.errorMessages = this.options.errorMessages;
            this.view.collection = this.errors;
            this.view.afterBindCollection();

            return this;
        },

        updateErrorsCollection: function(errors) {
            this.errors.updateErrorsCollection(errors);
        },

        scrollToError: function() {
            Odigeo.trigger('page:scrollTo', {
                top: this.view.getContainerTopPosition(),
            });
        },
    }));
